import React, { useCallback, useMemo } from "react";
import { Automation } from "../../../api/automation";
import { Box } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Card from "../../cards/Card";
import { AutomationConditionDisplay } from "./AutomationDisplay";
import moment from "moment-timezone";
import FormButton from "../../forms/FormButton";
import { Logger } from "../../../api/loggers";

const LastTriggeredDisplay: React.FC<{
  automation: Automation;
}> = ({ automation }) => {
  const last_triggered =
    automation.last_triggered &&
    moment(automation.last_triggered).format("h:mm a");

  return last_triggered ? (
    <small>Last activated at {last_triggered} today</small>
  ) : null;
};

export const AutomationCard: React.FC<{
  automations: Automation[];
  loggers: Logger[];
  onDelete: (id: number) => void;
}> = ({ automations, onDelete, loggers }) => {
  const history = useHistory();

  const isDeleted = useMemo(
    () => automations.at(0)?.field_name === "Deleted Field",
    [automations]
  );
  const viewDetails = useCallback((id: number) => {
    history.push(`/automation/config/${id}`);
  }, []);

  const fieldName = useMemo(() => automations.at(0)?.field_name, [automations]);

  return (
    <Card headline={fieldName} headlineVariant="h3" divider={true}>
      <Box>
        {automations.map((automation) => (
          <Box key={automation.id} borderBottom="1px solid #ccc" pb={2} mt={2}>
            <Box>
              <Box fontWeight="bold" mb={1}>
                {automation.name}
                {automation.data.disabled ? " (disabled)" : ""}
              </Box>
              <AutomationConditionDisplay
                conditions={automation.data.conditions}
                loggers={loggers}
              />
              <LastTriggeredDisplay automation={automation} />
              <Box display="flex" justifyContent="center" mt={1}>
                <FormButton
                  text="Delete Automation"
                  variant="contained"
                  handleClick={() => onDelete(automation.id)}
                />
                {!isDeleted && (
                  <FormButton
                    text="View Details"
                    variant="contained"
                    color="primary"
                    handleClick={() => viewDetails(automation.id)}
                  />
                )}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Card>
  );
};
